<template>
  <div class="enterprise-network_container">
    <div class="enterprise-network_container_title">
      Main Contact
    </div>
    <div class="enterprise-network_container_table">
      <el-row class="enterprise-network_mb-40">
        <el-col :span="12">
          <div class="enterprise-network_label">Name</div>
          <div class="enterprise-network_value">
            {{ formData.generalManagerName || "-" }}
          </div>
        </el-col>
        <el-col :span="12">
          <div class="enterprise-network_label">Work Email</div>
          <div class="enterprise-network_value">{{ formData.email || "-" }}</div>
        </el-col>
      </el-row>
      <el-row class="enterprise-network_mb-40">
        <el-col :span="12">
          <div class="enterprise-network_label">Job Title</div>
          <div class="enterprise-network_value">{{ formData.position || "-" }}</div>
        </el-col>
        <el-col :span="12">
          <div class="enterprise-network_label">Office Phone</div>
          <div class="enterprise-network_value">{{ formData.officePhone || "-" }}</div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "enterpriseNetworkMainContact",
  props: {
    formData: {
      type: Object,
      default: () => ({}),
    }
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/enterpriseNetwork/components/mainContact/mainContactDetail.vue